import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import requirementsRoutes from './routes'

const { RouteChangeProgress } = common

export const RequirementsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "Requirements" */ 'modules/requirements/Requirements/pages/Requirements'
    )
)
export const RequirementsGroupRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "RequirementsGroup" */ 'modules/requirements/Requirements/pages/RequirementsGroup'
    )
)

const RequirementsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={requirementsRoutes.root} component={RequirementsRoute} />
      <Route
        exact
        path={`${requirementsRoutes.group}/:groupId`}
        component={RequirementsGroupRoute}
      />
      <Route path={requirementsRoutes.adaptiveLearning} component={RequirementsRoute} />
      <Redirect path='*' to={requirementsRoutes.root} />
    </Switch>
  </Suspense>
)

export default RequirementsRouting

export { requirementsRoutes } from './routes'
